import React, { memo } from "react";
import { Box, ClassNameMap, Grid, Typography } from "@mui/material";
import { PromptType } from "../../store/cardPrompt/types";
import pageStyles from "./../../pages/pageStyles";
import SectionWrapper from "../pageSections/SectionWrapper";

interface ItemDetailBinPrompt {
  binPrompt: PromptType[];
  styles: ClassNameMap;
}
const ItemDetailBinPrompt = ({ binPrompt, styles }: ItemDetailBinPrompt) => {
  const classes = pageStyles();

  return (
    <SectionWrapper isChild isWhiteBG title="Bin Prompt">
      <Grid item xs={12}>
        {binPrompt.map((data, index) => (
          <Grid key={index} item xs={12} className={classes.additionalDataBox}>
            <Box>
              <Box mb={1}>
                <Typography display="block" className={styles.textTitle}>
                  Label: {data.Label}
                </Typography>
              </Box>
              <Box mb={1} className={classes.truncate}>
                <Typography display="block" className={styles.textTitle}>
                  Hint: {data.Hint}
                </Typography>
              </Box>
              <Box mb={1} className={classes.truncate}>
                <Typography display="block" className={styles.textTitle}>
                  Type: {data.Type}
                </Typography>
              </Box>
              <Box mb={1} className={classes.truncate}>
                <Typography display="block" className={styles.textTitle}>
                  Min Characters: {data.MinCharacters}
                </Typography>
              </Box>
              <Box mb={1} className={classes.truncate}>
                <Typography display="block" className={styles.textTitle}>
                  Max Characters: {data.MaxCharacters}
                </Typography>
              </Box>
              <Box mb={1} className={classes.truncate}>
                <Typography display="block" className={styles.textTitle}>
                  Tag: {data.Tag}
                </Typography>
              </Box>
              <Box mb={1} className={classes.truncate}>
                <Typography display="block" className={styles.textTitle}>
                  Language: {data.Language}
                </Typography>
              </Box>
              <Box mb={1} className={classes.truncate}>
                <Typography display="block" className={styles.textTitle}>
                  Option
                </Typography>
                {data.Options.map((option, index) => (
                  <Grid
                    key={index}
                    item
                    xs={12}
                    className={classes.additionalDataBox}
                  >
                    <Box>
                      <Box mb={1}>
                        <Typography
                          display="block"
                          className={styles.textTitle}
                        >
                          Text: {option.Text}
                        </Typography>
                      </Box>
                      <Box mb={1} className={classes.truncate}>
                        <Typography
                          display="block"
                          className={styles.textTitle}
                        >
                          Value: {option.Value}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Box>
              <Box mb={1} className={classes.truncate}>
                <Typography display="block" className={styles.textTitle}>
                  Condition: {data.Condition}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </SectionWrapper>
  );
};

export default memo(ItemDetailBinPrompt);
